import { __rest, __spreadArrays, __assign } from '../../_virtual/_tslib.js';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import camelCase from 'lodash/camelCase';
import BackgroundImage from '../BackgroundImage/index.js';
import PhoneField from '../PhoneField/index.js';
import useClickOutside from '../../hooks/useClickOutside.js';
import DownArrow from './down-arrow.svg.js';
import countries from './countries.js';
import flagStyles from './flags.css.js';
import styles from './styles.css.js';

/**
 * Our components library doesn't have knowledge of image uploads, this is a hardcoded path via our
 * static-shared library is safe to reference in perpetuity
 */

var FLAG_SPRITE_URL = 'https://deal-img.imgix.net/static-shared/phone-field/flags_0bdb1e514cb1c39c.png';

var InternationalPhoneField = function InternationalPhoneField(_a) {
  var _b, _c;

  var _d = _a.prioritizedCountryCodes,
      prioritizedCountryCodes = _d === void 0 ? ['US', 'CA', 'GB'] : _d,
      _e = _a.defaultCountryCode,
      defaultCountryCode = _e === void 0 ? 'US' : _e,
      onChange = _a.onChange,
      errorText = _a.errorText,
      label = _a.label,
      labelHidden = _a.labelHidden,
      parsedPhoneNumber = _a.parsedPhoneNumber,
      className = _a.className,
      rest = __rest(_a, ["prioritizedCountryCodes", "defaultCountryCode", "onChange", "errorText", "label", "labelHidden", "parsedPhoneNumber", "className"]);
  /**
   * Check to see if there is a parsed phone number passed in and try to match the country code (US, CA, etc.)
   */


  var existingCountry = countries.find(function (country) {
    if (parsedPhoneNumber && parsedPhoneNumber.regionCode === country.code) {
      return country;
    }
  });
  /**
   * The default country is what comes off of the maybe parsed phone number, otherwise the default prop
   */

  var defaultCountry = existingCountry || countries.find(function (country) {
    return country.code === defaultCountryCode;
  });

  if (!defaultCountry) {
    throw new Error("Invalid default country code or country not found in list: " + defaultCountryCode);
  }

  var _f = useState(false),
      isMenuOpen = _f[0],
      setIsMenuOpen = _f[1];

  var _g = useState(parsedPhoneNumber && parsedPhoneNumber.nationalNumber || undefined),
      currentPhoneValue = _g[0],
      setCurrentPhoneValue = _g[1];

  var _h = useState(defaultCountry),
      currentCountry = _h[0],
      setCurrentCountry = _h[1];
  /**
   * Prioritize some countries to the top of the list, filter out any mismatches
   */


  var filteredPrioritzedCoutryCodes = prioritizedCountryCodes.filter(function (prioritizedCountryCode) {
    return countries.find(function (country) {
      return country.code === prioritizedCountryCode;
    });
  });

  var sortedCountries = __spreadArrays(filteredPrioritzedCoutryCodes.map(function (filteredPrioritizedCountryCode) {
    return countries.find(function (country) {
      return country.code === filteredPrioritizedCountryCode;
    });
  }), countries);

  var menuRef = useClickOutside(function () {
    setIsMenuOpen(false);
  });
  useEffect(function () {
    /**
     * Only trigger the onChange event if a country and phone are present,
     * otherwise invalidate the field and reset it.
     */
    if (currentCountry && currentPhoneValue) {
      onChange("" + currentCountry.dialCode + currentPhoneValue);
    } else if (currentPhoneValue !== undefined) {
      onChange('');
    }
  }, [currentCountry, currentPhoneValue]);
  var currentCountryFlag = flagStyles[camelCase("flag-" + currentCountry.code.toLowerCase())];
  return React.createElement("div", {
    className: styles.container
  }, !labelHidden && React.createElement("div", {
    className: styles.label
  }, label), React.createElement("div", {
    className: styles.field
  }, React.createElement("div", {
    className: styles.flagDropdown,
    ref: menuRef,
    onClick: function onClick() {
      return setIsMenuOpen(!isMenuOpen);
    }
  }, React.createElement("div", {
    className: styles.selectedCountry
  }, currentCountry && React.createElement(React.Fragment, null, React.createElement(BackgroundImage, {
    src: FLAG_SPRITE_URL,
    containerClassName: flagStyles.flagContainer,
    imageClassName: classnames(flagStyles.flag, currentCountryFlag),
    width: 512,
    height: 512
  }), React.createElement("span", {
    className: styles.dialCode
  }, currentCountry.dialCode), React.createElement(DownArrow, {
    width: 12,
    className: classnames(styles.downArrow, (_b = {}, _b[styles.inverseArrow] = isMenuOpen, _b))
  }))), React.createElement("div", {
    className: classnames(styles.selectList, (_c = {}, _c[styles.selectListExpanded] = isMenuOpen, _c))
  }, sortedCountries.map(function (country, idx) {
    var _a;

    return country && React.createElement("div", {
      key: idx,
      onClick: function onClick() {
        if (currentCountry && country.code !== currentCountry.code) {
          setCurrentCountry(country);
        }

        setIsMenuOpen(false);
      },
      className: classnames(styles.selectListRow, (_a = {}, _a[styles.bottomBorder] = idx === filteredPrioritzedCoutryCodes.length - 1, _a))
    }, country.name);
  }))), React.createElement(PhoneField, __assign({
    label: "",
    labelHidden: true,
    onChange: function onChange(event) {
      var phoneValue = event.target.value;
      setCurrentPhoneValue(phoneValue);
    },
    onFocus: function onFocus() {
      setIsMenuOpen(false);
    },
    defaultValue: currentPhoneValue,
    className: classnames(styles.phoneField, className)
  }, rest))), errorText && React.createElement("div", {
    className: styles.errorText
  }, errorText));
};

export default InternationalPhoneField;
//# sourceMappingURL=index.js.map
